import { Box, Grid, Typography, Link } from "@mui/material";
import { useState } from "react";
import { Colors } from "../../Assets/colors";

const TopNavbar = () => {
  const moreLinks = [
    {
      name: "University News",
      url: "https://hkust.edu.hk/news",
    },
    {
      name: "Academic Departments A-Z",
      url: "https://hkust.edu.hk/academics/list",
    },
    {
      name: "Life@HKUST",
      url: "https://hkust.edu.hk/lifehkust",
    },
    {
      name: "Library",
      url: "https://library.hkust.edu.hk/",
    },
    {
      name: "Map & Directions",
      url: "https://hkust.edu.hk/visit",
    },
    {
      name: "Jobs@HKUST",
      url: "https://hro.hkust.edu.hk/?btn1=btn_nav_06&main=welcome.html",
    },
    {
      name: "Faculty Profiles",
      url: "https://facultyprofiles.hkust.edu.hk/",
    },
    {
      name: "About HKUST",
      url: "https://hkust.edu.hk/about",
    },
  ];
  const BasicDivRow = {
    display: "flex",
    alignItems: "center",
    background: Colors.MainUSTColor,
    padding: "10px",
    height: "5vh",
  };
  const accordionText = { color: "#003366" };
  const [openAccordion, setOpenAccordion] = useState(false);

  return (
    <>
      <Box
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          transition: "0.2s ease-in-out",
        }}
      >
        {openAccordion ? (
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              marginBottom: "16px",
              transition: "0.2s ease-in-out",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Typography
                  color="#003366"
                  fontWeight={600}
                  fontSize="24px"
                  style={{ margin: "16px 0px" }}
                >
                  More About HKUST
                </Typography>
              </Grid>
              {moreLinks.map((more, i) => {
                return (
                  <Grid
                    item
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "6px",
                      boxSizing: "border-box",
                    }}
                    key={i}
                  >
                    <Link
                      href={more.url}
                      style={{ textDecoration: "none" }}
                      target="_blank"
                    >
                      <Typography style={accordionText}>{more.name}</Typography>
                    </Link>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ) : null}
        <Grid container columnSpacing={2}>
          <Grid
            item
            xs={9.5}
            sx={BasicDivRow}
            style={{
              justifyContent: "flex-end",
              marginRight: "1px",
              boxSizing: "border-box",
            }}
          >
            <Typography fontSize={12} style={{ color: Colors.White }}>
              DIVISION OF ENVIRONMENT AND SUSTAINBILITY
            </Typography>
          </Grid>
          <Grid
            item
            xs={1}
            sx={BasicDivRow}
            style={{
              marginRight: "1px",
              justifyContent: "center",
              paddingLeft: "10px",
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/Images/Icons/ChevronUp.png"}
              alt="Up"
              width="16px"
              style={{ cursor: "pointer", transition: "0.2s ease-in-out" }}
              onClick={() => setOpenAccordion(!openAccordion)}
            />
          </Grid>
          <Grid
            item
            columnGap={1}
            xs
            sx={BasicDivRow}
            style={{
              marginRight: "1px",
              justifyContent: "center",
              paddingLeft: "10px",
            }}
          >
            <Link
              href="https://scholar.google.com/citations?user=YQCgkyoAAAAJ&hl=en"
              style={{
                textDecoration: "none",
                color: "white",
                cursor: "pointer",
                display: "flex",
                flexDirection: "row",
                columnGap: "4px",
              }}
            >
              <Typography fontSize={12} style={{ color: Colors.White }}>
                Follow
              </Typography>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/Images/SocialMedia/google_scholar.png"
                }
                alt="Scholar"
                width="16px"
              />
            </Link>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default TopNavbar;
